module.exports = __webpack_public_path__ + "static/media/camp.9e684ae8.jpg";